<!-- Text Input -->
@if (name) {
  <label [id]="name + '_label'"
         class="flex flex-grow-1 mb-2"
         [for]="name">
    <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
      {{ 'global.route' | translate }}
    </span>
  </label>
  <div medsurf-design-content-input-group>
    <input id="{{ name }}"
     [attr.aria-labelledby]="name + '_label'"
     [type]="'text'"
     [class]="inputClass"
     [formControlName]="name"
     [ngClass]="{
      'ng-invalid': control.invalid && control.touched,
      'ng-dirty': control.invalid && control.touched
     }"
     (change)="valueChange.emit($event)"
     pInputText />
    <button [id]="name + '_route_from_title'"
      type="button"
      [class]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
      [title]="'global.route_from_title' | translate"
      [style.filter]="'none'"
      (click)="valueReset.emit($event)"
      pButton
      pRipple>
      <span class="font-bold w-auto white-space-nowrap overflow-hidden text-overflow-ellipsis">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.RELOAD"></i>
      </span>
    </button>
  </div>
  @if (control.invalid && (control.dirty || control.touched)) {
    <br/>
    @for (err of control.errors | keyvalue; track err) {
      <small [id]="name + '_help'"
        class="p-error">
        {{ err.value | translate }}
      </small>
      <br/>
    }
  }
}